var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._l((_vm.slices),function(slice,index){return [(slice.slice_type === 'featured_card_banner')?_c('FeaturedCardBanner',{key:index,attrs:{"slice":slice,"is-first":index === 0}}):_c(_vm.sliceType(slice.slice_type),{key:index,tag:"component",attrs:{"slice":slice,"is-first":index === 0}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }